<template>
  <v-layout row wrap>
    <v-flex xs12 class="text-sm-center">
      <span class="headline">SETTINGS</span>
    </v-flex>

    <v-flex xs12>
      <span class="headline">Categories</span>
      <v-data-table
        :headers="categoryHeaders"
        :items="categories"
        hide-actions
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">{{ props.item.category }}</td>
          <td class="text-xs-center">{{ props.item.active }}</td>
          <td class="justify-center layout px-0">
            <v-icon
              @click="updateCategory(props.item)"
            >
              edit
            </v-icon>
          </td>
        </template>
      </v-data-table>
    </v-flex>
    <v-flex xs12 class="justify-right layout px-0">
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="addCategory()">Add Category</v-btn>
    </v-flex>

    <v-flex xs12>
      <span class="headline">Pricing</span>
      <v-data-table
        :headers="priceHeaders"
        :items="prices"
        hide-actions
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">{{ props.item.location }}</td>
          <td class="text-xs-left">{{ props.item.description }}</td>
          <td class="text-xs-left">{{ props.item.code }}</td>
          <td class="text-xs-center">{{ props.item.per }}</td>
          <td class="text-xs-right">{{ props.item.price }}</td>
          <td class="text-xs-center">{{ props.item.active }}</td>
          <td class="justify-center layout px-0">
            <v-icon
              @click="updatePrice(props.item)"
            >
              edit
            </v-icon>
          </td>
        </template>
      </v-data-table>
    </v-flex>
    <v-flex xs12 class="justify-right layout px-0">
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="addPrice()">Add Price</v-btn>
    </v-flex>

    <v-flex xs12>
      <span class="headline">Email Templates</span>
      <v-data-table
        :headers="emailHeaders"
        :items="emails"
        hide-actions
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">{{ props.item.subject }}</td>
          <td class="text-xs-center">{{ props.item.status }}</td>
          <td class="justify-center layout px-0">
            <v-icon
              @click="updateEmail(props.item)"
            >
              edit
            </v-icon>
          </td>
        </template>
      </v-data-table>
    </v-flex>
    <v-flex xs12 class="justify-right layout px-0">
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="addEmail()">Add Email Template</v-btn>
    </v-flex>

    <v-dialog
      v-model="categoryDialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="600px"
      scrollable
      persistent
    >
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add/Edit Category</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model="editedItem.category"
                  @keyup.enter="save"
                  label="Name"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md3>
                <v-select
                  v-model="editedItem.active"
                  :items="yesNo"
                  label="Active"
                ></v-select>
              </v-flex>
              <v-flex xs12 class="justify-right layout px-0">
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="saveCategory()">Save</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="priceDialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="600px"
      scrollable
      persistent
    >
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add/Edit Price</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout class="pb-3" row wrap>
              <v-flex xs12 md6>
                <v-select
                  v-model="editedItem.location"
                  :items="locations"
                  item-text="name"
                  item-value="value"
                  label="Location"
                ></v-select>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                  v-model="editedItem.description"
                  @keyup.enter="save"
                  label="Description"
                ></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field
                  v-model="editedItem.code"
                  @keyup.enter="save"
                  label="Code"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-select
                  v-model="editedItem.per"
                  :items="per"
                  label="Per"
                ></v-select>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="editedItem.price"
                  @keyup.enter="save"
                  label="Amount"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md4>
                <v-select
                  v-model="editedItem.invoice"
                  :items="yesNo"
                  label="Invoice"
                ></v-select>
              </v-flex>
              <v-flex xs6 md4>
                <v-select
                  v-model="editedItem.default"
                  :items="yesNo"
                  label="Default"
                ></v-select>
              </v-flex>
              <v-flex xs6 md4>
                <v-select
                  v-model="editedItem.active"
                  :items="yesNo"
                  label="Active"
                ></v-select>
              </v-flex>
              <v-flex xs12 class="justify-right layout px-0">
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="savePrice()">Save</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="emailDialog"
      :fullscreen="$vuetify.breakpoint.smAndDown"
      max-width="1000px"
      scrollable
      persistent
    >
      <v-card >
        <v-toolbar card dark color="primary">
          <v-btn icon dark @click="close()">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Add/Edit Email</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-card-text>
          <v-layout>
            <v-flex xs8>
              <v-container grid-list-md>
                <v-layout class="pb-3" wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.name"
                      @keyup.enter="save"
                      label="Name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedItem.subject"
                      @keyup.enter="save"
                      label="Subject"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm4>
                    <v-select
                      v-model="editedItem.status"
                      :items="status"
                      label="Status"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <wysiwyg v-model="editedItem.text" />
                  </v-flex>
                  <v-flex xs12 class="justify-right layout px-0">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="saveEmail()">Save</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
            <v-flex xs3>
              Company - <b>%company%</b><br />
              Password - <b>%password%</b><br />
              Contact First Name - <b>%firstname%</b><br />
              Contact Last Name - <b>%lastname%</b><br />
              Booth(s) - <b>%booth%</b><br />
              Payment Type - <b>%ptype%</b><br />
              Payment Amount - <b>%pamount%</b>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line=true
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn
        dark
        flat
        @click="snackbar.show = false"
      >
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import Api from '@/services/Api'

export default {
  props: ['visible'],

  data () {
    return {
      myId: this.$store.state.user.id,
      page: 'settings',
      loading: false,
      locations: [
        {value: 'All', name: 'All'},
        {value: 'Vendor Alley', name: 'Vendor Alley'},
        {value: 'Food Court', name: 'Food Court'},
        {value: 'Grounds', name: 'Grounds'}
      ],
      yesNo: ['Yes', 'No'],
      per: ['sqft', 'ea'],
      status: ['active', 'inactive'],
      categoryHeaders: [
        {text: 'Category', align: 'center', sortable: false, value: 'type'},
        {text: 'Active', align: 'center', sortable: false, value: 'active'},
        {text: 'Edit', align: 'center', sortable: false, value: 'id'}
      ],
      categories: [],
      categoryDialog: false,
      priceHeaders: [
        {text: 'Location', align: 'center', sortable: false, value: 'location'},
        {text: 'Description', align: 'center', sortable: false, value: 'description'},
        {text: 'Code', align: 'center', sortable: false, value: 'code'},
        {text: 'Per', align: 'center', sortable: false, value: 'per'},
        {text: 'Price', align: 'center', sortable: false, value: 'price'},
        {text: 'Active', align: 'center', sortable: false, value: 'active'},
        {text: 'Edit', align: 'center', sortable: false, value: 'id'}
      ],
      prices: [],
      priceDialog: false,
      emails: [],
      emailHeaders: [
        {text: 'Name', align: 'left', sortable: false, value: 'name'},
        {text: 'Subject', align: 'left', sortable: false, value: 'subject'},
        {text: 'Status', align: 'center', sortable: false, value: 'status'},
        {text: 'Edit', align: 'center', sortable: false, value: 'id'}
      ],
      emailDialog: false,
      editedItem: {},
      snackbar: {
        show: false,
        color: '',
        message: ''
      }
    }
  },

  created () {
    this.loading = true

    window.addEventListener('resize', this.handleResize)
    this.handleResize()

    this.getCategories()
    this.getPrices()
    this.getEmails()

    this.loading = false
  },

  destroyed () {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    handleResize () {
      const height = window.innerHeight - 360
      this.height = height + 'px'
    },

    async getCategories () {
      try {
        const response = await Api().get('all_categories/')
        this.categories = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    addCategory () {
      this.categoryDialog = true
    },

    updateCategory (item) {
      this.editedItem = item
      this.categoryDialog = true
    },

    async saveCategory () {
      try {
        let response
        if (this.editedItem.id > 0) {
          response = await Api().put('categories/' + this.editedItem.id, this.editedItem)
        } else {
          response = await Api().post('categories/', this.editedItem)

          this.categories.push(response.data.category)
        }

        this.categoryDialog = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getPrices () {
      try {
        const response = await Api().get('all_prices/')
        this.prices = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    addPrice () {
      this.priceDialog = true
    },

    updatePrice (item) {
      this.editedItem = item
      this.priceDialog = true
    },

    async savePrice () {
      try {
        let response
        if (this.editedItem.id > 0) {
          response = await Api().put('prices/' + this.editedItem.id, this.editedItem)
        } else {
          response = await Api().post('prices/', this.editedItem)

          this.prices.push(response.data.price)
        }

        this.priceDialog = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    async getEmails () {
      try {
        const response = await Api().get('get_email_templates/Vendor')
        this.emails = response.data
        this.isTableLoading = false
      } catch (error) {
        this.error = error.response.data.error
      }
    },

    addEmail () {
      this.emailDialog = true
    },

    updateEmail (item) {
      this.editedItem = item
      this.emailDialog = true
    },

    async saveEmail () {
      this.editedItem.section = 'Vendor'
      this.editedItem.UserId = this.myId

      try {
        let response
        if (this.editedItem.id > 0) {
          response = await Api().put('email_templates/' + this.editedItem.id, this.editedItem)
        } else {
          response = await Api().post('email_templates/', this.editedItem)

          this.emails.push(response.data.email)
        }

        this.emailDialog = false
        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (error) {
        this.snackbar.message = error.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    close () {
      this.categoryDialog = false
      this.priceDialog = false
      this.emailDialog = false
      this.editedItem = {}
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>



// WEBPACK FOOTER //
// src/components/vendor/Settings.vue